import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {Observable} from 'rxjs';
import {ICruisePrefetch} from '../../../shared/interfaces/icruise-prefetch';
import {MobileService} from '../../../shared/services/mobile.service';
import {WidgetService} from '../../../shared/services/widget.service';

@Component({
  selector: 'app-engine-cruise-select-ship',
  templateUrl: './engine-cruise-select-ship.component.html',
  styleUrls: ['./engine-cruise-select-ship.component.scss']
})
export class EngineCruiseSelectShipComponent implements OnInit, OnChanges {

  public isMobile$: Observable<boolean>;
  public isWidget$: Observable<boolean>;

  constructor(private _mobileService: MobileService,
              private _widgetService: WidgetService) { }

  @Output() selectedShip: EventEmitter<number> = new EventEmitter<number>();
  @Input() defaultShip: number | string;
  @Input() cruisePrefetch$: Observable<ICruisePrefetch>;
  selectedShipInner: any;

  ngOnInit(): void {
    this.isMobile$ = this._mobileService.isMobile();
    this.isWidget$ = this._widgetService.isWidget();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.defaultShip && this.defaultShip) {
      this.defaultShip = Number(this.defaultShip);
      this.selectedShipInner = JSON.parse(JSON.stringify(this.defaultShip));
      this.selectedShip.emit(this.selectedShipInner);
    }
  }

  selectShip(ship: any): void {
    this.selectedShipInner = ship ? ship.Id : undefined;
    this.selectedShip.emit(this.selectedShipInner);
  }

}
